import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_users } from '@/graphql/queries'

export default {
  data() {
    return {
      adminsList: [],

    }
  },
  methods: {
    async fetchAdmins() {


      try {
        const response = await client.graphql({
          query: list_users
        })

        let responseData = JSON.parse(response.data.list_users)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.adminsList = responseData.data
        } else {
          this.adminsList = []
        }
        // console.log(this.adminsList)

      } catch (error) {
        console.error("Error fetching admins:", error);
        this.adminsList = [];
        throw error;
      }
    },
  },
};
